<div class="success-container">
  <div class="success-content">
    <div class="success-icon">✓</div>
    <h1>Payment Successful!</h1>
    <p class="success-message">Your order has been placed successfully using your Arkifi Shopping Card.</p>
    
    @if (orderId()) {
      <div class="order-info">
        <p class="order-id">Order ID: <span>{{ orderId() }}</span></p>
      </div>
    }
    
    @if (amountDeducted() !== null) {
      <div class="payment-details">
        <p class="amount-deducted">Amount Deducted: <span>₦{{ amountDeducted() | number:'1.2-2' }}</span></p>
      </div>
    }
    
    @if (remainingBalance() !== null) {
      <div class="balance-info">
        <p class="remaining-balance">Remaining Balance: <span>₦{{ remainingBalance() | number:'1.2-2' }}</span></p>
      </div>
    }
    
    <button 
      type="button" 
      pButton 
      label="Continue Shopping" 
      (click)="continueShopping()" 
      class="p-button-primary continue-btn">
    </button>
  </div>
</div>

<p-toast position="bottom-right"></p-toast>
